const getPage = (index, pageSize) => {
  let page = 0;

  if (pageSize === 100) {
    if (index >= 100 && index <= 199) {
      page = 1;
    } else if (index >= 200 && index <= 299) {
      page = 2;
    } else if (index >= 300 && index <= 399) {
      page = 3;
    } else if (index >= 400 && index <= 499) {
      page = 4;
    } else if (index >= 500 && index <= 599) {
      page = 5;
    } else if (index >= 600 && index <= 699) {
      page = 6;
    } else if (index >= 700 && index <= 799) {
      page = 7;
    } else if (index >= 800 && index <= 899) {
      page = 8;
    } else if (index >= 900 && index <= 999) {
      page = 9;
    } else if (index >= 1000 && index <= 1099) {
      page = 10;
    } else if (index >= 1100 && index <= 1199) {
      page = 11;
    } else if (index >= 1200 && index <= 1299) {
      page = 12;
    } else if (index >= 1300 && index <= 1399) {
      page = 13;
    } else if (index >= 1400 && index <= 1499) {
      page = 14;
    } else if (index >= 1500 && index <= 1599) {
      page = 15;
    } else if (index >= 1600 && index <= 1699) {
      page = 16;
    } else if (index >= 1700 && index <= 1799) {
      page = 17;
    } else if (index >= 1800 && index <= 1899) {
      page = 18;
    } else if (index >= 1900 && index <= 1999) {
      page = 19;
    } else if (index >= 2000 && index <= 2099) {
      page = 20;
    } else if (index >= 2100 && index <= 2199) {
      page = 21;
    } else if (index >= 2200 && index <= 2299) {
      page = 22;
    } else if (index >= 2300 && index <= 2399) {
      page = 23;
    } else if (index >= 2400 && index <= 2499) {
      page = 24;
    } else if (index >= 2500 && index <= 2599) {
      page = 25;
    } else if (index >= 2600 && index <= 2699) {
      page = 26;
    }
  }

  return page;
};

export default { getPage };

export const concatenateDateTime = (startDate, startTime, endDate, endTime) => {
  var resultStart = "";

  if (startDate !== null) {
    let splitStart = startDate.toString().split("00:00:00");
    startTime = startTime !== "" ? startTime + ":00" : "00:00:01";
    resultStart = new Date(
      Date.parse(splitStart[0] + " " + startTime + " " + splitStart[1])
    );
  }

  if (endDate !== null) {
    endTime = endTime !== "" ? endTime + ":00" : "23:59:59";
  }

  var result = [{ resultStart }, { endDate }];

  return result;
};

export const dateConsistency = (startDate, endDate) => {
  if (startDate === null || endDate === null) {
    return true;
  }

  if (startDate <= endDate) {
    return true;
  }

  return false;
};

export const getBase64FileFormat = (base64) => {
  if (!!!base64) return "";

  let data = base64.substring(0, 5).toUpperCase();
  switch (data) {
    case "IVBOR":
      return "png";
    case "/9J/4":
      return "jpg";
    case "JVBER":
      return "pdf";
    default:
      return "";
  }
};

export const removeBase64Header = (string) => {
  return string.replace("data:", "").replace(/^.+,/, "");
};

// check if string contains a number
// if it has letter and number it will return false
export const isNumber = (string) => {
  if (+string === +string) {
    return true;
  }
  return false;
};

export const checkSampleCode = (value) => {
  if (value.length < 16) {
    return "invalid format";
  }

  if (value.length > 16) {
    value = value.substring(value.length - 16);
  }

  // const ReplaceURL = getSystemParameter("MO_S_OUTSIDE_URL").textValue;
  //TODO chamar busca de parametro
  // if (value.includes(ReplaceURL)) value = value.replace(ReplaceURL, "");

  let type = value.substring(0, 1),
    year = value.substring(1, 2),
    customer = value.substring(2, 3),
    sample = value.substring(3, 4),
    date = value.substring(4, 8),
    number = value.substring(8, 16);

  if (type !== "4") {
    return "invalid format";
  }

  if (isNumber(year)) {
    return "invalid format";
  }

  if (isNumber(customer)) {
    return "invalid format";
  }

  if (sample !== "S") {
    return "invalid format";
  }

  if (!isNumber(date)) {
    return "invalid format";
  }

  if (!isNumber(number)) {
    return "invalid format";
  }

};

export const getSystemParameter = (parameter_name) => {
  const parameterList = JSON.parse(sessionStorage.getItem("parameterList"));
  let result = [];
  if (parameterList) {
    result = parameterList.filter((item) => {
      return item.parameter === parameter_name;
    });
  }

  return result[0];
};

export const handleSampleCodeURL = (sampleCode) => {
  if (sampleCode.length > 16) {
    let slashLastIndex = sampleCode.lastIndexOf("/");
    if (slashLastIndex < 0) {
      //slash not found on string
      slashLastIndex = sampleCode.lastIndexOf(";"); //sometimes slash is converted to ; when readed from a barcode scanner
    }
    sampleCode = sampleCode.substring(slashLastIndex + 1);
    //sampleCode = sampleCode.substring(sampleCode.length - 16);
  }

  return sampleCode;
};

export const serviceExceptionLog = (string) => {
  console.log(
    "%c" + "Service Exception: " + "%c" + string,
    "color:red",
    "font-weight: bold"
  );
};

export const handleOpenAttachment = (event) => {
  const { item } = event;

  let fileExtension = getBase64FileFormat(item);

  if (!!fileExtension) {
    let image = new Image();

    switch (fileExtension) {
      case "pdf":
        const windowPdf = window.open();
        windowPdf.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
          encodeURI(item) +
          "'></iframe>"
        );
        break;
      case "png":
        const windowPng = window.open();
        image.src = "data:image/png;base64," + item;
        windowPng.document.write(image.outerHTML);
        break;
      case "jpg":
        const windowJpg = window.open();
        image.src = "data:image/jpg;base64," + item;
        windowJpg.document.write(image.outerHTML);
        break;
    }
  }
};

export const TreatResponse = (data) => {
  if (!data.length > 0) return;

  data.forEach((item) => {
    Object.keys(item).forEach((value) => {
      if (!!item[value]) {
        if (item[value] === -2147483648) item[value] = "";

        if (item[value].toString().includes("00:00:00")) {
          item[value] = item[value].toString().split(" ", 1);
        }
      }
    });
  });

  data.forEach((item, index) => {
    item.id = index;
  });

  return data;
};

/*
  parameter - js Date + 00:00
  return - yyyy-mm-dd 00:00:00
*/
export const ConcatenateDateAndTime = (date, time) => {
  if (!!!date) return;

  let year = date.getFullYear(),
    month = "" + (date.getMonth() + 1),
    day = "" + date.getDate();

  if (month.length < 2) month = "0" + month;

  if (day.length < 2) day = "0" + day;

  let resultDate = [year, month, day].join("-");

  time = !!time ? time + ":00" : "00:00:00";

  return [resultDate, time].join(" ");
};

export const dateIsValid = (date) => {
  return date.toString() !== "Invalid Date";
};
/*
  parameter - JS Date
  return - dd/mm/yyyy
*/
export const convertDate = (date) => {
  return date.toISOString().substr(0, 10).split("-").reverse().join("/");
};

export const convertJsonDateTime = (date) => {
  return date.toString().substr(0, 10).split("/").reverse().join("-") + date.toString().substr(10);
};

export const treatPrintFilter = (string) => {
  return !!string ? string : " - ";
};

export const getFormatedDate = () => {
  let date = new Date();
  return convertDate(date);
};

export const getFormatedDateTime = () => {
  let date = new Date(),
    time = new Date();

  return (
    date.toISOString().substr(0, 10).split("-").reverse().join("/").toString() +
    " " +
    time.toISOString().slice(11, 19).replace("T", " ").toString()
  );
};

export const getTime = () => {
  // HH:mm
  let hours = new Date().getHours();
  let minutes = new Date().getMinutes();

  hours = hours.toString().length === 1 ? `0${hours}` : hours;
  minutes = minutes.toString().length === 1 ? `0${minutes}` : minutes;

  return `${hours}:${minutes}`;
};

export const getTimeFromDateTime = (date) => {
  return date.toString().substr(16, 5)
}

export const checkDecimalPlaces = (value, DecimalPlacesQtty) => {
  value = value.replace(",", ".");
  if (value.includes(".")) {
    if (value.split(".")[1].length > DecimalPlacesQtty) {
      //Has more decimal places than DecimalPlacesQtty return false
      return false;
    } else {
      //Has less decimal places than DecimalPlacesQtty return false
      return true;
    }
  } else {
    //no decimal places
    return true;
  }
};

export const handleSampleCode = (sampleCode) => {
  if (sampleCode.length > 16) {
    const checkedSampleCode = checkSampleCode(sampleCode);
    switch (checkedSampleCode) {
      case "invalid format":
        break;
      case "not exist":
        break;
      default:
        return checkSampleCode;
    }
  } else {
    return sampleCode;
  }
};

export const getHighestZIndex = () =>
  [...document.querySelectorAll("body *")]
    .map((elt) => parseFloat(getComputedStyle(elt).zIndex))
    .reduce((highest, z) => (z > highest ? z : highest), 1);

//if is date check also -> Object.getPrototypeOf(obj) === Object.prototype
export const isEmptyObject = obj => {
  for (let i in obj) return false
  return true
};

export const handleSelectResponse = (response, tsCanceled) => {
  if (!isEmptyObject(response))
    response.data.forEach((item) => {
      if (!item.status) item.name = `${item.name} (${tsCanceled})`;
    });
  return response.data;
};

//create html element, add id and pass it as parameter
//timeout is to give time to html render
export const scrollTo = (elementId) =>
  setTimeout(() => document.getElementById(elementId).scrollIntoView(), 100);

export const getCsIntMinValue = () => {
  return -2147483648;
};

export const replaceInvalidChar = (str) => {
  return str.replaceAll("–", "-");
};

export const stringToFloat = (string) => {
  if (typeof string === "number") {
    return parseFloat(string);
  }
  if (string === "") {
    return 0;
  }
  if (!string.includes(".") && !string.includes(",")) {
    return parseFloat(string);
  }
  if (string.includes(",")) {
    string = string.replace(",", ".");
  }
  const decimalPlaces = string.split(".")[1].length;
  return parseFloat(string).toFixed(decimalPlaces);
};

//#region DefaultDatagridV2
const handleIds = event => {
  let ids
  if (Array.isArray(event.data)) {
    ids = event.data.map(e => e.id)
  } else {
    ids = [event.data.id]
  }
  return ids
}

export const handleCheckboxRowSelected = (event, selectedRows) => {
  let ids = handleIds(event)
  let newSelectedRows = [...selectedRows]
  ids.forEach(e => { if (!newSelectedRows.includes(e)) newSelectedRows.push(e) })
  return newSelectedRows
}

export const handleCheckboxRowDeselected = (event, selectedRows) => {
  let ids = handleIds(event)
  let newSelectedRows = []
  selectedRows.forEach(e => { if (!ids.includes(e)) newSelectedRows.push(e) })
  return newSelectedRows
}

//lower case to Pascal case 
export const toPascalCase = str => { return `${str[0].toUpperCase()}${str.slice(1)}` };

//{data : ""} => {Data : ""}
export const capitalize = (object) => {
  var isArray = Array.isArray(object);
  for (let key in object) {
    let value = object[key];
    let newKey = key;
    if (!isArray) {
      delete object[key];
      newKey = key.charAt(0).toUpperCase() + key.slice(1);
    }
    let newValue = value;
    if (typeof value != "object") {
      if (typeof value == "string") {
        newValue = value
      }
    } else {
      newValue = capitalize(value);
    }
    object[newKey] = newValue;
  }
  return object;
}


//Format Exemple : May 15, Sunday
export const TranslateDayString = (dayString, t) => {
  const splited = dayString.replace(',', '').split(' ');
  let [month, dayNumber, day] = splited;

  month = t(`${month.charAt(0).toLowerCase()}${month.slice(1)}`)
  day = t(`${day.charAt(0).toLowerCase()}${day.slice(1)}`)


  return (`${month} ${dayNumber}, ${day}`)

}